import axios from 'axios';

const tryImportingElegibles = (promoId, file, setLoadingImport, setErrorImport, setSuccessImport) => {
    if (!file) {
        setErrorImport([{ row: 1, message: 'Arquivo obrigatório.' }]);
        setSuccessImport('');
        return;
    }
    setLoadingImport(true);
    const formData = new FormData();
    formData.append('file', file);
    axios
        .post(`${process.env.REACT_APP_API_URL}/admin/elegiveis?promo_id=${promoId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${localStorage.getItem('adminAccessToken')}`
            },
        })
        .then((response) => {
            setLoadingImport(false);
            setSuccessImport(`${response.data.result.success_count} itens importados com sucesso.`);
            setErrorImport(response.data.result.errors);
        })
        .catch((err) => {
            setSuccessImport('');
            setErrorImport([{ row: 1, message: err.response.data.message }]);
            setLoadingImport(false);
        })
}

export default tryImportingElegibles;